export default {
  // 老师后台
  // 修改作业
  putTeacherAssignment: '/api/teacher/assignment/{0}',
  // Seminar分数设置
  putTeacherGradeCourse: '/api/teacher/grade/course/{0}/{1}',
  // 作业打分
  putTeacherGrade: '/api/teacher/grade/stu/{0}',
  // 更新
  putAdminHouseCup: '/api/admin/house-cup/{0}',
  // 教师端更新小队信息
  putActivityMissionX: '/api/activity/mission-x/{0}',
  //#region Seminar 课程
  putCourseCenterSeminarRate: '/api/course-center/seminar-rate/{0}',
  //#endregion
  //#region  消息中心
  // 消息更新
  pustAdminMessages: '/api/admin/messages/{0}',
  //#endregion
  // 是否有护照
  putStudentHXWeekPassportOwn: '/api/student/hx-week/passport-own',
  // 学校建议
  putSchoolStuApplyrecommend: '/api/school/student-apply/recommend',
  // 学校建议-成为SI
  putSchoolStuApplyrecommendSI: '/api/school/student-apply/recommend-si',
  // 管理端-学生管理-修改请假
  putAdminStudentsIdTimeSheetsId: '/api/admin/students/{0}/time-sheets/{1}',
  // 管理端-学生管理-修改备注
  putAdminStudentsIdRemarks: '/api/admin/students/{0}/remarks',
  // CP-Feedback小组列表
  putTeacherCPFeedback: '/api/teacher/cp-feedback/{0}'
};
